import RegionDialog from './RegionDialog';

export default RegionDialog;
